import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { ProjectCreatedTitle } from "../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { GeneralGrowth } from "../../../../Data/General/Widgets/General";

const ProjectCreated = () => {
  return (
    <Col sm="6">
      <Card>
        <DashboardCommonHeader title={ProjectCreatedTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="p-0">
          <div id="general-growth">
            <ReactApexChart options={GeneralGrowth} series={GeneralGrowth.series} type="area" height={310} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProjectCreated;
